
export const storeProducts = [
  {
    id: 1,
    title: "Google Pixel",
    img: "img/product-1.png",
    price: 24000,
    company: "GOOGLE",
    info:
    "Google Pixel is based on Android 7.1 and packs 32GB of inbuilt storage. The Google Pixel is a single SIM (GSM) smartphone that accepts a Nano-SIM card. The Google Pixel measures 143.80 x 69.50 x 8.60mm (height x width x thickness) and weighs 143.00 grams. It was launched in Black, Quite Black, Silver, and Very Silver colours. Connectivity options on the Google Pixel include Wi-Fi 802.11 a/b/g/n/ac, GPS, Bluetooth v4.20, NFC, 3G, and 4G (with support for Band 40 used by some LTE networks in India). Sensors on the phone include accelerometer, ambient light sensor, barometer.",
    inCart: false,
    count: 0,
    total: 0
  },
  {
    id: 2,
    title: "Samsung S7",
    img: "img/product-2.png",
    price: 27500,
    company: "SAMSUNG",
    info:
    "Samsung's brand new Galaxy S7 is a subtle improvement over its predecessor on the outside, but a whole new beast on the inside. Powered by the Exynos 8890 SoC, this phone can blaze through absolutely anything you throw at it, with power to spare. The camera is absolutely amazing, especially in low light. This is a pragmatic phone, compared to its sibling the Galaxy S7 Edge, and is better value for money if you don't want to show off. However, with competition at an all-time high, you can also get most of its features and functions for one third this price.",
    inCart: false,
    count: 0,
    total: 0
  },
  {
    id: 3,
    title: "HTC 10 - Black",
    img: "img/product-3.png",
    price: 24000,
    company: "htc",
    info:
    "The HTC 10 is a beautifully crafted smartphone with a gorgeous display and an ergonomic design. This phone is the first to have optical image stabilisation for the front facing camera, which does help when shooting in low light. The phone has very snappy performance thanks to the Snapdragon 820 SoC, 4GB of RAM and 32GB of onboard storage. The USB Type-C port gets USB 3.1 Gen 1 speeds for faster data transfers. Sense UI is now leaner than ever, with many of the custom apps traded in favour of Google's native apps. Camera performance is good thanks to the 12 Ultrapixel 2 sensor.",
    inCart: false,
    count: 0,
    total: 0
  },
  {
    id: 4,
    title: "HTC 10 - White",
    img: "img/product-4.png",
    price: 25000,
    company: "htc",
    info:
    "The HTC 10 is a beautifully crafted smartphone with a gorgeous display and an ergonomic design. This phone is the first to have optical image stabilisation for the front facing camera, which does help when shooting in low light. The phone has very snappy performance thanks to the Snapdragon 820 SoC, 4GB of RAM and 32GB of onboard storage. The USB Type-C port gets USB 3.1 Gen 1 speeds for faster data transfers. Sense UI is now leaner than ever, with many of the custom apps traded in favour of Google's native apps. Camera performance is good thanks to the 12 Ultrapixel 2 sensor.",
    inCart: false,
    count: 0,
    total: 0
  },
  {
    id: 5,
    title: "HTC Desire 626s",
    img: "img/product-5.png",
    price: 24000,
    company: "htc",
    info:
    "Designed with all-over beauty to be stunning both inside and out. The colorful design stands out, making the smooth, thin body of the phone as beautiful on the eye as it is in the hand. Its sleek finish and bold design give it an energetic look that fits your style. 8 Megapixel Camera & 2 Megapixel Front Camera, Camera Flash, HD Camcorder, HD VoiceFull Corporate Email & Calendar Support, FM Radio, GPSAndroid 5.1 Lollipop Touchscreen, 1GB RAM, 8GB ROMLTE capable, WiFi Calling Capable, Autofocus,5 HD DisplayAdreno 305 (Snapdragon 410) Mali-450 MP (MT6592)",

    inCart: false,
    count: 0,
    total: 0
  },
  {
    id: 6,
    title: "Vintage Iphone",
    img: "img/product-6.png",
    price: 17000,
    company: "apple",
    info:
    " The phone comes with a touchscreen display with a resolution of 320x480 pixels at a pixel density of 165 pixels per inch (ppi). Apple iPhone 3GS is powered by a 600 MHz one-core processor. It comes with 256MB of RAM.As far as the cameras are concerned, the Apple iPhone 3GS on the rear packs 3.15-megapixel camera.Apple iPhone 3GS is based on iOS 6.1.3 and packs 8GB of inbuilt storage. The Apple iPhone 3GS is a single SIM (GSM) smartphone that accepts a Regular-SIM card. The Apple iPhone 3GS measures 115.50 x 62.10 x 12.30mm (height x width x thickness) and weighs 135.00 grams.",
    inCart: false,
    count: 0,
    total: 0
  },
  {
    id: 7,
    title: "Iphone 7",
    img: "img/product-7.png",
    price: 30000,
    company: "apple",
    info:
    "The phone comes with a 4.70-inch touchscreen display with a resolution of 750x1334 pixels at a pixel density of 326 pixels per inch (ppi) and an aspect ratio of 16:9. Apple iPhone 7 is powered by a 2.34GHz quad-core Apple A10 Fusion processor. It comes with 2GB of RAM. The Apple iPhone 7 runs iOS 10 and is powered by a 1960mAh non-removable battery.Apple iPhone 7 is based on iOS 10 and packs 32GB of inbuilt storage. The Apple iPhone 7 is a single SIM (GSM) smartphone that accepts a Nano-SIM card. The Apple iPhone 7 measures 138.30 x 67.10 x 7.10mm (height x width x thickness) and weighs 138.00 grams.",
    inCart: false,
    count: 0,
    total: 0
  },
  {
    id: 8,
    title: "Smashed Iphone",
    img: "img/product-8.png",
    price: 20000,
    company: "apple",
    info:
      "Lorem ipsum dolor amet offal butcher quinoa sustainable gastropub, echo park actually green juice sriracha paleo. Brooklyn sriracha semiotics, DIY coloring book mixtape craft beer sartorial hella blue bottle. Tote bag wolf authentic try-hard put a bird on it mumblecore. Unicorn lumbersexual master cleanse blog hella VHS, vaporware sartorial church-key cardigan single-origin coffee lo-fi organic asymmetrical. Taxidermy semiotics celiac stumptown scenester normcore, ethical helvetica photo booth gentrify.",
    inCart: false,
    count: 0,
    total: 0
  }
  // {
  //   id: 9,
  //   title: "Google Pixel",
  //   img: "img/product-1.png",
  //   price: 24000,
  //   company: "GOOGLE",
  //   info:
  //     "Lorem ipsum dolor amet offal butcher quinoa sustainable gastropub, echo park actually green juice sriracha paleo. Brooklyn sriracha semiotics, DIY coloring book mixtape craft beer sartorial hella blue bottle. Tote bag wolf authentic try-hard put a bird on it mumblecore. Unicorn lumbersexual master cleanse blog hella VHS, vaporware sartorial church-key cardigan single-origin coffee lo-fi organic asymmetrical. Taxidermy semiotics celiac stumptown scenester normcore, ethical helvetica photo booth gentrify.",
  //   inCart: false,
  //   count: 0,
  //   total: 0
  // },
  // {
  //   id: 10,
  //   title: "Samsung S7",
  //   img: "img/product-2.png",
  //   price: 27500,
  //   company: "SAMSUNG",
  //   info:
  //     "Lorem ipsum dolor amet offal butcher quinoa sustainable gastropub, echo park actually green juice sriracha paleo. Brooklyn sriracha semiotics, DIY coloring book mixtape craft beer sartorial hella blue bottle. Tote bag wolf authentic try-hard put a bird on it mumblecore. Unicorn lumbersexual master cleanse blog hella VHS, vaporware sartorial church-key cardigan single-origin coffee lo-fi organic asymmetrical. Taxidermy semiotics celiac stumptown scenester normcore, ethical helvetica photo booth gentrify.",
  //   inCart: false,
  //   count: 0,
  //   total: 0
  // },
  // {
  //   id: 11,
  //   title: "HTC 10 - Black",
  //   img: "img/product-3.png",
  //   price: 24000,
  //   company: "htc",
  //   info:
  //     "Lorem ipsum dolor amet offal butcher quinoa sustainable gastropub, echo park actually green juice sriracha paleo. Brooklyn sriracha semiotics, DIY coloring book mixtape craft beer sartorial hella blue bottle. Tote bag wolf authentic try-hard put a bird on it mumblecore. Unicorn lumbersexual master cleanse blog hella VHS, vaporware sartorial church-key cardigan single-origin coffee lo-fi organic asymmetrical. Taxidermy semiotics celiac stumptown scenester normcore, ethical helvetica photo booth gentrify.",
  //   inCart: false,
  //   count: 0,
  //   total: 0
  // },
  // {
  //   id: 12,
  //   title: "HTC 10 - White",
  //   img: "img/product-4.png",
  //   price: 25000,
  //   company: "htc",
  //   info:
  //     "Lorem ipsum dolor amet offal butcher quinoa sustainable gastropub, echo park actually green juice sriracha paleo. Brooklyn sriracha semiotics, DIY coloring book mixtape craft beer sartorial hella blue bottle. Tote bag wolf authentic try-hard put a bird on it mumblecore. Unicorn lumbersexual master cleanse blog hella VHS, vaporware sartorial church-key cardigan single-origin coffee lo-fi organic asymmetrical. Taxidermy semiotics celiac stumptown scenester normcore, ethical helvetica photo booth gentrify.",
  //   inCart: false,
  //   count: 0,
  //   total: 0
  // },
  // {
  //   id: 13,
  //   title: "HTC Desire 626s",
  //   img: "img/product-5.png",
  //   price: 24000,
  //   company: "htc",
  //   info:
  //     "Lorem ipsum dolor amet offal butcher quinoa sustainable gastropub, echo park actually green juice sriracha paleo. Brooklyn sriracha semiotics, DIY coloring book mixtape craft beer sartorial hella blue bottle. Tote bag wolf authentic try-hard put a bird on it mumblecore. Unicorn lumbersexual master cleanse blog hella VHS, vaporware sartorial church-key cardigan single-origin coffee lo-fi organic asymmetrical. Taxidermy semiotics celiac stumptown scenester normcore, ethical helvetica photo booth gentrify.",
  //   inCart: false,
  //   count: 0,
  //   total: 0
  // },
  // {
  //   id: 14,
  //   title: "Vintage Iphone",
  //   img: "img/product-6.png",
  //   price: 17000,
  //   company: "apple",
  //   info:
  //     "Lorem ipsum dolor amet offal butcher quinoa sustainable gastropub, echo park actually green juice sriracha paleo. Brooklyn sriracha semiotics, DIY coloring book mixtape craft beer sartorial hella blue bottle. Tote bag wolf authentic try-hard put a bird on it mumblecore. Unicorn lumbersexual master cleanse blog hella VHS, vaporware sartorial church-key cardigan single-origin coffee lo-fi organic asymmetrical. Taxidermy semiotics celiac stumptown scenester normcore, ethical helvetica photo booth gentrify.",
  //   inCart: false,
  //   count: 0,
  //   total: 0
  // },
  // {
  //   id: 15,
  //   title: "Iphone 7",
  //   img: "img/product-7.png",
  //   price: 30000,
  //   company: "apple",
  //   info:
  //     "Lorem ipsum dolor amet offal butcher quinoa sustainable gastropub, echo park actually green juice sriracha paleo. Brooklyn sriracha semiotics, DIY coloring book mixtape craft beer sartorial hella blue bottle. Tote bag wolf authentic try-hard put a bird on it mumblecore. Unicorn lumbersexual master cleanse blog hella VHS, vaporware sartorial church-key cardigan single-origin coffee lo-fi organic asymmetrical. Taxidermy semiotics celiac stumptown scenester normcore, ethical helvetica photo booth gentrify.",
  //   inCart: false,
  //   count: 0,
  //   total: 0
  // },
  // {
  //   id: 16,
  //   title: "Smashed Iphone",
  //   img: "img/product-8.png",
  //   price: 20000,
  //   company: "apple",
  //   info:
  //     "Lorem ipsum dolor amet offal butcher quinoa sustainable gastropub, echo park actually green juice sriracha paleo. Brooklyn sriracha semiotics, DIY coloring book mixtape craft beer sartorial hella blue bottle. Tote bag wolf authentic try-hard put a bird on it mumblecore. Unicorn lumbersexual master cleanse blog hella VHS, vaporware sartorial church-key cardigan single-origin coffee lo-fi organic asymmetrical. Taxidermy semiotics celiac stumptown scenester normcore, ethical helvetica photo booth gentrify.",
  //   inCart: false,
  //   count: 0,
  //   total: 0
  // }
];

export const detailProduct = {
  id: 1,
  title: "Google Pixel",
  img: "img/product-1.png",
  price: 24000,
  company: "google",
  info:
    "Lorem ipsum dolor amet offal butcher quinoa sustainable gastropub, echo park actually green juice sriracha paleo. Brooklyn sriracha semiotics, DIY coloring book mixtape craft beer sartorial hella blue bottle. Tote bag wolf authentic try-hard put a bird on it mumblecore. Unicorn lumbersexual master cleanse blog hella VHS, vaporware sartorial church-key cardigan single-origin coffee lo-fi organic asymmetrical. Taxidermy semiotics celiac stumptown scenester normcore, ethical helvetica photo booth gentrify.",
  inCart: false,
  count: 0,
  total: 0
};
